import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import layout from './modules/layout'
import chat from './modules/im'

Vue.use(Vuex)

const store = new Vuex.Store({
  getters,
  modules: {
    layout,
    chat,
  },
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js